import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import Popover from "../../components/uielements/popover";
import IntlMessages from "../../components/utility/intlMessages";
import userpic from "../../image/profile-user.svg";
import TopbarDropdownWrapper from "./topbarDropdown.style";
import { withFirebase } from "../../components/firebase";
import { Link } from "react-router-dom";
import FilterPermission from "../../Utility/FilterPermission";
import PermissionStrings from "../../Utility/PermissionStrings";
import colors from "../../Utility/colorFactory";
import webFont from "../../Utility/fontSizes";

class TopbarUser extends Component {
  constructor(props) {
    super(props);
    this.handleVisibleChange = this.handleVisibleChange.bind(this);
    this.hide = this.hide.bind(this);
    this.logout = this.logout.bind(this);
    this.state = {
      redirect: false,
      visible: false,
    };
  }
  hide() {
    this.setState({ visible: false });
  }
  handleVisibleChange() {
    this.setState({ visible: !this.state.visible });
  }

  logout() {
    var superThis = this;
    this.props.firebase.auth.signOut().then(function() {
      superThis.props.firebase.switchOffChannels();
      localStorage.removeItem("loggedInEmail");
      localStorage.removeItem("isGod");
      localStorage.removeItem("loggedInEncodedEmail");
      localStorage.removeItem("user");
      localStorage.removeItem("schoolDBName");
      localStorage.removeItem("selectedDBName");
      localStorage.removeItem("schoolConfig");
      localStorage.removeItem("schoolName");
      localStorage.removeItem("secondaryConfig");
      localStorage.removeItem("selectedBranchPath");
      localStorage.removeItem("selectedMode");
      localStorage.removeItem("student");
      localStorage.removeItem("teacher");
      localStorage.removeItem("studentList");
      localStorage.removeItem("classList");
      localStorage.removeItem("teacherList");
      localStorage.removeItem("groupList");
      localStorage.removeItem("permissionList");
      localStorage.removeItem("permissionRoles");
      localStorage.removeItem("permissionTypes");
      localStorage.removeItem("developmentAreas");
      localStorage.removeItem("milestones");
      localStorage.removeItem("timezone");
      localStorage.removeItem("branchList");
      localStorage.removeItem("classmap");
      localStorage.removeItem("searchedString");
      localStorage.removeItem("lastLeadsFilter");
      localStorage.removeItem("currentStudentId");
      localStorage.removeItem("defaultTimezone");
      localStorage.removeItem("unfilteredClassList");
      localStorage.removeItem("infoCardCount");
      superThis.props.firebase.user = undefined;
      superThis.props.firebase.teacher = undefined;
      superThis.props.firebase.student = undefined;
      superThis.props.firebase.isParent = false;
      superThis.props.firebase.branchList = null;
      superThis.props.firebase.selectedMode = null;
      superThis.props.firebase.isLoggedIn = false;
      superThis.props.firebase.studentsMap = new Map();
      superThis.setState({ redirect: true });
    });
  }

  render() {
    const { firebase } = this.props;
    if (this.state.redirect) {
      return (
        <Redirect
          to={{
            pathname: "/signin",
          }}
        />
      );
    }
    const content = (
      <TopbarDropdownWrapper className="isoUserDropdown">
        {firebase.isParent !== undefined && firebase.isParent ? null : (
          <div>
            {firebase && firebase.teacher ? (
              <div className="isoDropdownLink" style={styles.divBorder}>
                <p style={styles.userName}>{firebase.teacher.name}</p>
                {firebase.loggedInEmail ? (
                  <p style={styles.loggedUserId}>{firebase.loggedInEmail}</p>
                ) : null}
              </div>
            ) : null}
            {FilterPermission.checkIfPermission(
              PermissionStrings.SETTINGS_VIEW_CHANGE,
              firebase
            ) ? (
              <div>
                <Link className="isoDropdownLink" to="/dashboard/setting">
                  <IntlMessages id="themeSwitcher.settings" />
                </Link>

                <Link
                  className="isoDropdownLink"
                  to="/dashboard/enableActivity"
                >
                  <IntlMessages id="topbar.enableDisableActivities" />
                </Link>

                <Link className="isoDropdownLink" to="/dashboard/minorSettings">
                  <IntlMessages id="topbar.miscellaneousSettings" />
                </Link>
              </div>
            ) : null}

            {FilterPermission.checkIfPermission(
              PermissionStrings.SM_ADD_UPDATE,
              firebase
            ) ? (
              <Link className="isoDropdownLink" to="/dashboard/onboarding">
                <IntlMessages id="topbar.Onboarding" />
              </Link>
            ) : null}
          </div>
        )}

        <a className="isoDropdownLink" onClick={() => this.logout()} href="# ">
          <IntlMessages id="topbar.logout" />
        </a>
      </TopbarDropdownWrapper>
    );

    let profileImg = userpic;
    let externalProfile = false;
    if (firebase && firebase.teacher && firebase.teacher.profileImageUrl) {
      profileImg = firebase.teacher.profileImageUrl;
      externalProfile = true;
    }

    return (
      <Popover
        content={content}
        trigger="click"
        visible={this.state.visible}
        onVisibleChange={this.handleVisibleChange}
        arrowPointAtCenter={true}
        placement="bottomLeft"
      >
        <div className="isoImgWrapper">
          <img
            alt="user"
            src={profileImg}
            style={externalProfile ? styles.bordered : null}
          />
          <span
            style={{ color: colors.v2_fiord }}
            className="userActivity online"
          />
        </div>
      </Popover>
    );
  }
}
export default withFirebase(TopbarUser);
const styles = {
  bordered: {
    borderRadius: "20%",
    width: "55px",
  },
  userName: {
    margin: 0,
    fontWeight: "bold",
  },
  divBorder: {
    borderBottom: "1px solid",
    height: 50,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    marginBottom: 10,
  },
  loggedUserId: {
    fontSize: webFont.defaultFont,
    maxWidth: "100%",
    margin: 0,
    WebkitLineClamp: 1,
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
};
